@switch (style()) {
  @case ('basic') {
    <button
      mat-button
      class="eiq-button"
      [attr.data-testid]="testId() ? testId() + '-button' : null"
      [matTooltip]="title()"
      [color]="color()"
      [ngClass]="[align(), active(), expand(), size(), background()]"
      [disabled]="disabled() || loading()"
      (click)="clicked.emit()"
    >
      @if (loading()) {
        <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="textContainer"></ng-container>
      }
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      class="eiq-button"
      [attr.data-testid]="testId() ? testId() + '-button' : null"
      [matTooltip]="title()"
      [color]="color()"
      [ngClass]="[align(), active(), expand(), size(), background()]"
      [disabled]="disabled() || loading()"
      (click)="clicked.emit()"
    >
      @if (loading()) {
        <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="textContainer"></ng-container>
      }
    </button>
  }
  @case ('stroked') {
    <button
      mat-stroked-button
      class="eiq-button"
      [attr.data-testid]="testId() ? testId() + '-button' : null"
      [matTooltip]="title()"
      [color]="color()"
      [ngClass]="[align(), active(), expand(), size(), background()]"
      [disabled]="disabled() || loading()"
      (click)="clicked.emit()"
    >
      @if (loading()) {
        <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="textContainer"></ng-container>
      }
    </button>
  }
  @case ('icon') {
    <button
      mat-icon-button
      class="eiq-button"
      [attr.data-testid]="testId() ? testId() + '-button' : null"
      [matTooltip]="title()"
      [color]="color()"
      [ngClass]="[align(), active(), expand(), size(), background()]"
      [disabled]="disabled() || loading()"
      (click)="clicked.emit()"
    >
      @if (loading()) {
        <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="iconContainer"></ng-container>
      }
    </button>
  }
  @case ('fab') {
    <button
      mat-mini-fab
      class="eiq-button"
      [attr.data-testid]="testId() ? testId() + '-button' : null"
      [matTooltip]="title()"
      [color]="color()"
      [ngClass]="[align(), active(), expand(), size(), background()]"
      [disabled]="disabled() || loading()"
      (click)="clicked.emit()"
    >
      @if (loading()) {
        <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="iconContainer"></ng-container>
      }
    </button>
  }
}

<ng-template #loadingContainer>
  <div class="eiq-button__loading">
    <mat-spinner diameter="20" color="light"></mat-spinner>
    <span>{{ loadingText() }}</span>
  </div>
</ng-template>

<ng-template #textContainer>
  <div class="eiq-button__text-icon" [ngClass]="iconPosition()">
    @if (avatar()) {
      <empathy-avatar [size]="'sm'" [text]="avatar()"></empathy-avatar>
    }
    @if (icon()) {
      <fa-icon [icon]="icon()" [ngClass]="iconColor() ? 'eiq-icon-' + iconColor() : ''"></fa-icon>
    }
    @if (svgIcon()) {
      <mat-icon [svgIcon]="svgIcon()"></mat-icon>
    }
    <span>{{ text() }}</span>
    <ng-content select="[slot=extended-text]"></ng-content>
    <ng-container *ngTemplateOutlet="secondaryIconContainer"></ng-container>
  </div>
</ng-template>

<ng-template #iconContainer>
  <div class="eiq-button__text-icon" [ngClass]="iconPosition()">
    @if (icon()) {
      <fa-icon [icon]="icon()" [ngClass]="iconColor() ? 'eiq-icon-' + iconColor() : ''"></fa-icon>
    }
    @if (svgIcon()) {
      <mat-icon [svgIcon]="svgIcon()"></mat-icon>
    }
  </div>
</ng-template>

<ng-template #secondaryIconContainer>
  @if (secondaryIcon()) {
    <div class="eiq-button__text-icon" [ngClass]="secondaryIconPosition()">
      <fa-icon [icon]="secondaryIcon()" [ngClass]="secondaryIconColor()"></fa-icon>
    </div>
  }
</ng-template>
